import { useHeaders } from "ssr-hook";
import { useTitle } from "easy-page-router/react";

export function useHead(title: string, description: string) {
    useHeaders({
        title,
        description,
        image: `/images/icon.png`, // Zde je možné zapojit dynamické generování jako v titimeme
        canonical: typeof window !== "undefined" ? window.location.origin + window.location.pathname : "",
    });
    useTitle(title);
}
